import React from "react";
import styles from "./index.module.scss";
import { Tabs } from "antd";
import { useHistory } from "react-router-dom";
import { useAtomValue } from "jotai";
import {
    NoticeCountAtom,
    SystemMsgCountAtom
} from "../../../../Stores/CommonStore";

interface NoticeLayoutProps {
    tab: string;
    children: React.ReactNode;
}

export function NoticeLayout({ tab, children }: NoticeLayoutProps) {
    const history = useHistory();
    const systemCount = useAtomValue(SystemMsgCountAtom);
    const noticeCount = useAtomValue(NoticeCountAtom);

    function onChangeTab(activeKey: string) {
        if (activeKey === "system") history.replace(`/notice/system`);
        else history.replace(`/notice`);
    }

    return (
        <div className={styles.root}>
            <Tabs activeKey={tab} onChange={onChangeTab}>
                <Tabs.TabPane key="system" tab={`互动消息 (${systemCount})`} />
                <Tabs.TabPane key="notice" tab={`通知 (${noticeCount})`} />
            </Tabs>

            <div className={styles.body}>{children}</div>
        </div>
    );
}
